// `Notification.*` / `NotificationSettings.*` i18n keys — bell dropdown, list page, settings page.

export const notificationDict: Record<string, [en: string, th: string]> = {
  // Router / menu
  "Notification.pageTitle": ["Notifications", "การแจ้งเตือน"],
  "Notification.breadcrumb": ["Notifications", "การแจ้งเตือน"],
  "NotificationSettings.pageTitle": ["Notification Settings", "ตั้งค่าการแจ้งเตือน"],
  "NotificationSettings.breadcrumb": ["Notification Settings", "ตั้งค่าการแจ้งเตือน"],
  "menu.notificationSettings": ["Notifications", "การแจ้งเตือน"],

  // Bell dropdown
  "Notification.title": ["Notifications", "การแจ้งเตือน"],
  "Notification.unreadSuffix": ["unread", "ยังไม่อ่าน"],
  "Notification.markAllRead": ["Mark all as read", "อ่านแล้วทั้งหมด"],
  "Notification.viewAll": ["View all", "ดูทั้งหมด"],
  "Notification.emptyUnread": ["You're all caught up", "อ่านครบทุกรายการแล้ว"],

  // List page
  "Notification.filterAll": ["All", "ทั้งหมด"],
  "Notification.filterUnread": ["Unread", "ยังไม่อ่าน"],
  "Notification.filterRead": ["Read", "อ่านแล้ว"],
  "Notification.filterType": ["Type", "ประเภท"],
  "Notification.filterPriority": ["Priority", "ความสำคัญ"],
  "Notification.colNotification": ["Notification", "การแจ้งเตือน"],
  "Notification.colType": ["Type", "ประเภท"],
  "Notification.colPriority": ["Priority", "ความสำคัญ"],
  "Notification.colDate": ["Date", "วันที่"],
  "Notification.colActions": ["Actions", "จัดการ"],
  "Notification.markRead": ["Mark as read", "ทำเครื่องหมายว่าอ่านแล้ว"],
  "Notification.delete": ["Delete", "ลบ"],
  "Notification.deleteConfirmTitle": ["Delete notification?", "ลบการแจ้งเตือน?"],
  "Notification.deleteConfirmBtn": ["Delete", "ลบ"],
  "Notification.deleted": ["Notification deleted", "ลบการแจ้งเตือนแล้ว"],
  "Notification.clearRead": ["Clear read", "ลบที่อ่านแล้ว"],
  "Notification.clearReadConfirmTitle": ["Delete all read notifications?", "ลบการแจ้งเตือนที่อ่านแล้วทั้งหมด?"],
  "Notification.clearReadConfirmText": [
    "Every read notification will be permanently deleted. Unread ones are kept.",
    "รายการที่อ่านแล้วทั้งหมดจะถูกลบถาวร ส่วนที่ยังไม่อ่านจะยังอยู่",
  ],
  "Notification.clearReadConfirmBtn": ["Delete read", "ลบที่อ่านแล้ว"],
  "Notification.clearedRead": ["Deleted {count} notification(s)", "ลบแล้ว {count} รายการ"],
  "Notification.markedRead": ["Marked as read", "ทำเครื่องหมายว่าอ่านแล้ว"],
  "Notification.markedAllRead": ["All notifications marked as read", "ทำเครื่องหมายอ่านแล้วทั้งหมด"],
  "Notification.empty": ["No notifications found", "ไม่พบการแจ้งเตือน"],
  "Notification.loadFailed": ["Failed to load notifications", "โหลดการแจ้งเตือนไม่สำเร็จ"],
  "Notification.actionFailed": ["Action failed", "ดำเนินการไม่สำเร็จ"],
  "Notification.refresh": ["Refresh", "รีเฟรช"],

  // Type labels (enum keys from the backend)
  "Notification.type.inventory_alert": ["Unauthorized Exit (RFID)", "นำออกไม่ได้รับอนุญาต (RFID)"],
  "Notification.type.low_stock": ["Low Stock", "สต๊อกใกล้หมด"],
  "Notification.type.reorder_alert": ["Reorder Alert", "แจ้งเตือนสั่งซื้อเพิ่ม"],
  "Notification.type.out_of_stock": ["Out of Stock", "สินค้าหมด"],
  "Notification.type.bottle_return_reminder": ["Bottle Return", "เตือนคืนขวด"],
  "Notification.type.purchase_request": ["Purchase Request", "คำขอสั่งซื้อ"],
  "Notification.type.approval": ["Approval", "การอนุมัติ"],
  "Notification.type.system": ["System", "ระบบ"],

  // Priority labels
  "Notification.priority.low": ["Low", "ต่ำ"],
  "Notification.priority.normal": ["Normal", "ปกติ"],
  "Notification.priority.high": ["High", "สูง"],
  "Notification.priority.urgent": ["Urgent", "ด่วน"],

  // Settings page
  "NotificationSettings.title": ["Notification Settings", "ตั้งค่าการแจ้งเตือน"],
  "NotificationSettings.subtitle": [
    "Per-company preferences for alerts and delivery channels",
    "การตั้งค่าการแจ้งเตือนและช่องทางส่งของบริษัท",
  ],
  "NotificationSettings.alertSection": ["Alert Types", "ประเภทการแจ้งเตือน"],
  "NotificationSettings.alertSectionHint": [
    "Choose what to be notified about. Each type carries its own related settings.",
    "เลือกว่าจะให้แจ้งเตือนเรื่องอะไรบ้าง — การตั้งค่าที่เกี่ยวข้องของแต่ละเรื่องอยู่ในกล่องเดียวกัน",
  ],
  "NotificationSettings.inventoryEnabled": ["Inventory alerts", "แจ้งเตือนสต๊อก (ใกล้หมด/หมด)"],
  "NotificationSettings.inventoryEnabledHint": [
    "Fires immediately when a wine drops to the threshold or runs out, and auto-closes when stock recovers.",
    "เด้งทันทีเมื่อไวน์เหลือถึงเกณฑ์หรือหมดสต๊อก และปิดใบแจ้งเตือนให้เองเมื่อสต๊อกกลับมาเกินเกณฑ์",
  ],
  "NotificationSettings.bottleReturnEnabled": ["Bottle return reminders", "เตือนคืนขวดค้างเบิก"],
  "NotificationSettings.bottleReturnEnabledHint": [
    "A recurring summary of bottles checked out and not yet returned, at the cadence below.",
    "สรุปขวดที่เบิกออกแล้วยังไม่คืน ส่งซ้ำตามรอบเวลาที่ตั้งด้านล่าง",
  ],
  "NotificationSettings.gateAlert": ["Unauthorized exit (RFID Gate)", "นำขวดออกโดยไม่ได้รับอนุญาต (RFID Gate)"],
  "NotificationSettings.gateAlertHint": [
    "Security alert — fires immediately when the gate detects a bottle leaving without a checkout. Cannot be turned off.",
    "แจ้งเตือนความปลอดภัย — เด้งทันทีเมื่อประตูตรวจพบขวดถูกนำออกโดยไม่มีใบเบิก (ปิดไม่ได้)",
  ],
  "NotificationSettings.alwaysOn": ["Always on", "เปิดเสมอ"],
  "NotificationSettings.lowStockThreshold": ["Low-stock threshold (bottles)", "เกณฑ์สต๊อกใกล้หมด (ขวด)"],
  "NotificationSettings.lowStockThresholdHint": [
    "Alert when a wine's in-stock count falls to this level or below. 0 disables low-stock alerts. A wine's own min_stock overrides this.",
    "แจ้งเตือนเมื่อไวน์เหลือ ≤ ค่านี้ (0 = ปิด) — ตั้งรายไวน์ได้ด้วย min_stock ซึ่งจะใช้แทนค่านี้",
  ],
  "NotificationSettings.channelSection": ["Delivery Channels", "ช่องทางการส่ง"],
  "NotificationSettings.channelSectionHint": [
    "Where notifications are delivered. Alerts always appear in the in-app list regardless.",
    "แจ้งเตือนจะถูกส่งไปทางไหนบ้าง — ทุกใบยังดูย้อนหลังได้ในหน้ารายการแจ้งเตือนเสมอ",
  ],
  "NotificationSettings.websocketEnabled": ["In-app (realtime)", "ในแอป (เรียลไทม์)"],
  "NotificationSettings.websocketEnabledHint": [
    "Bell badge on web and mobile updates instantly while the app is open.",
    "กระดิ่งบนเว็บและแอปมือถืออัปเดตทันทีระหว่างเปิดใช้งาน",
  ],
  "NotificationSettings.emailEnabledHint": [
    "Email digest — under development, no emails are sent yet.",
    "สรุปทางอีเมล — กำลังพัฒนา ตอนนี้ยังไม่มีการส่งจริง",
  ],
  "NotificationSettings.lineEnabledHint": [
    "LINE messages — under development, nothing is sent yet.",
    "แจ้งผ่าน LINE — กำลังพัฒนา ตอนนี้ยังไม่มีการส่งจริง",
  ],
  "NotificationSettings.emailEnabled": ["Email", "อีเมล"],
  "NotificationSettings.pushEnabled": ["Push notification", "พุชแจ้งเตือน"],
  "NotificationSettings.pushEnabledHint": [
    "Sends to the mobile app (FCM) — devices register automatically on login.",
    "ส่งเข้าแอปมือถือ (FCM) — เครื่องจะลงทะเบียนอัตโนมัติเมื่อ login แอป",
  ],
  "NotificationSettings.lineEnabled": ["LINE", "LINE"],
  "NotificationSettings.comingSoon": ["Coming soon", "เร็ว ๆ นี้"],
  "NotificationSettings.notifySchedule": ["Delivery timing", "รอบการส่ง"],
  "NotificationSettings.notifyScheduleHint": [
    "Currently the system delivers realtime (per event). Hourly/Daily are reserved for the upcoming email digest.",
    "ตอนนี้ระบบส่งแบบ \"ทันที\" ตามเหตุการณ์ — ตัวเลือกรายชั่วโมง/รายวันเตรียมไว้สำหรับอีเมลสรุปในอนาคต ยังไม่มีผลตอนนี้",
  ],
  "NotificationSettings.schedule.realtime": ["Realtime", "ทันที"],
  "NotificationSettings.schedule.hourly": ["Hourly", "รายชั่วโมง"],
  "NotificationSettings.schedule.daily": ["Daily", "รายวัน"],
  "NotificationSettings.reminderInterval": ["Remind every (hours)", "เตือนซ้ำทุก (ชั่วโมง)"],
  "NotificationSettings.reminderIntervalHint": [
    "How often: a bottle counts as overdue after this many hours, and at most one summary is sent per cycle (12 = ~twice a day).",
    "ความถี่: เบิกเกินกี่ชั่วโมงถือว่าค้าง และส่งสรุปไม่เกิน 1 ครั้งต่อรอบ (12 = วันละ ~2 ครั้ง)",
  ],
  "NotificationSettings.maxReminderDays": ["Stop reminding after (days)", "หยุดเตือนเมื่อค้างเกิน (วัน)"],
  "NotificationSettings.maxReminderDaysHint": [
    "How long: bottles overdue past this many days stop being reminded — handle them as lost/written-off instead.",
    "ความนาน: ขวดที่ค้างเกินกี่วันจะเลิกเตือนถาวร — ควรไปจัดการเป็นสูญหาย/ตัดยอดแทน",
  ],
  "NotificationSettings.retentionSection": ["Data Retention (auto-delete)", "การลบข้อมูลอัตโนมัติ"],
  "NotificationSettings.retentionSectionHint": [
    "Keeps the notification list clean by deleting old items automatically.",
    "ช่วยเก็บกวาดรายการแจ้งเตือนเก่าให้อัตโนมัติ ไม่ต้องลบเอง",
  ],
  "NotificationSettings.autoCleanupEnabled": ["Auto-delete old notifications", "ลบการแจ้งเตือนเก่าอัตโนมัติ"],
  "NotificationSettings.autoCleanupHint": [
    "Runs daily on the server. Unread notifications are only removed by the maximum-age rule.",
    "ระบบลบให้อัตโนมัติวันละครั้ง — รายการที่ยังไม่อ่านจะถูกลบเมื่อเกินอายุสูงสุดเท่านั้น",
  ],
  "NotificationSettings.cleanupReadAfterDays": ["Delete read after (days)", "ลบที่อ่านแล้วเมื่อเก่ากว่า (วัน)"],
  "NotificationSettings.cleanupReadAfterDaysHint": [
    "Read/auto-archived notifications older than this are deleted. 0 = keep forever.",
    "รายการที่อ่านแล้ว/ปิดอัตโนมัติ เก่ากว่านี้จะถูกลบ (0 = เก็บตลอด)",
  ],
  "NotificationSettings.cleanupAllAfterDays": ["Maximum age — delete all after (days)", "อายุสูงสุด — ลบทุกรายการเมื่อเก่ากว่า (วัน)"],
  "NotificationSettings.cleanupAllAfterDaysHint": [
    "Hard cap: anything older than this is deleted, read or not. 0 = keep forever.",
    "เพดานสูงสุด: เก่ากว่านี้ลบหมดไม่ว่าอ่านหรือยัง (0 = เก็บตลอด)",
  ],
  "NotificationSettings.recipientSection": ["Default Recipients", "ผู้รับเริ่มต้น"],
  "NotificationSettings.defaultRecipients": ["Fallback recipients", "ผู้รับเมื่อไม่ได้ระบุเป้าหมาย"],
  "NotificationSettings.defaultRecipientsHint": [
    "Leave empty = everyone in the company receives alerts. Pick people = only they receive (applies to both in-app and push).",
    "ปล่อยว่าง = ทุกคนในบริษัทได้รับแจ้งเตือน • เลือกคน = ส่งเฉพาะคนที่เลือกเท่านั้น (มีผลทั้งกระดิ่งและพุชมือถือ)",
  ],
  "NotificationSettings.save": ["Save", "บันทึก"],
  "NotificationSettings.saved": ["Notification settings saved", "บันทึกการตั้งค่าแล้ว"],
  "NotificationSettings.loadFailed": ["Failed to load notification settings", "โหลดการตั้งค่าไม่สำเร็จ"],
  "NotificationSettings.saveFailed": ["Failed to save notification settings", "บันทึกการตั้งค่าไม่สำเร็จ"],
};
